import { sortBy } from "lodash";
import React, { FC, useMemo } from "react";
import { useFormContext } from "react-hook-form";

import { getSanitizedHtmlFromAllTags } from "../../../../../utils/get-sanitized-html-from-all-tags";
import { getTechSheetFieldSlugifiedName } from "../../../../../utils/products";
import { Select } from "../../../../forms";
import { EMPTY_OPTION_VALUE } from "../../constants";
import { ProductFinderFiltersFormTypes } from "../../types";

export interface SingleSelectFieldFilterProps extends Queries.TechSheetFieldDataFragment {
  labels: {
    "product-finder-panel-option-all": string;
  };
}

export const SingleSelectFieldFilter: FC<SingleSelectFieldFilterProps> = ({
  internalName,
  label,
  allowedValues,
  labels,
}) => {
  const fieldName = getTechSheetFieldSlugifiedName(internalName ?? "");
  const { watch, setValue } = useFormContext<ProductFinderFiltersFormTypes>();
  const orderedAllowedValues = useMemo(
    () => sortBy(allowedValues, (value) => value?.value?.toLowerCase()),
    [allowedValues]
  );

  return (
    <div className="flex-grow flex-shrink-0 flex items-end" key={fieldName}>
      <Select
        className="w-full"
        label={label}
        value={watch(fieldName) as string}
        onChange={(e) => setValue(fieldName, e.target.value)}
      >
        <option value={EMPTY_OPTION_VALUE}>{labels["product-finder-panel-option-all"]}</option>
        {(orderedAllowedValues ?? []).map((option) => {
          const label = getSanitizedHtmlFromAllTags(option?.value);
          return option?.value && option.internalName ? (
            <option key={option.internalName} value={option.internalName}>
              {label}
            </option>
          ) : null;
        })}
      </Select>
    </div>
  );
};
